import $ from "jquery";
import {getCurrentLoanLimit, getCurrentUsdBalanceAmount, getRequestLoanAmount} from "./output";
import {MAX_AMOUNT_VALUE} from "./instant";
import {refillNoMoneyModalDisplay} from "./refillNoMoney";
import {refillNotEnoughModalDisplay} from "./refillNotEnoughMoney";

let processedAmount = 0;

export const NON_VISIBLE = 'd-none',
      INFO_BACKGR = 'info-background',
      INFO_BACKGR_CONTENT = 'info-background-content',
      CALC_USD_TYPE = 'usd',
      CALC_BTC_TYPE = 'btc';

export const checkTxStatus = (txWaitSelector, txConfirmSelector, txOnlineSelector, txConfirmationSelector, btcAddr, modalSelector) => {
    const waitPaymentBlock = txWaitSelector;
    const confirmationBlock = txConfirmSelector;
    const transactionOnlineBlock = txOnlineSelector;
    const txConfirmationBlock = txConfirmationSelector;
    const checkUrl = '/fund/status/' + btcAddr;
    $.ajax({
        type: 'GET',
        url: checkUrl,
        data: {},
        success: function (data) {
            if (data) {
                $.each(data, function (key, result) {
                    if (!result.processed) {
                        if (result.confirmations === 0) {
                            waitPaymentBlock.addClass(NON_VISIBLE);
                            confirmationBlock.addClass(NON_VISIBLE);
                            transactionOnlineBlock.removeClass(NON_VISIBLE)
                        }
                        if (result.confirmations > 0) {
                            waitPaymentBlock.addClass(NON_VISIBLE);
                            transactionOnlineBlock.addClass(NON_VISIBLE)
                            txConfirmationBlock.text(result.confirmations);
                            confirmationBlock.removeClass(NON_VISIBLE);
                        }

                    }
                    if (result.processed) {
                        processedAmount = result.amount;
                        showRefillSuccessModal(processedAmount, modalSelector);
                    }
                });
            }
        }
    });
}

const showRefillSuccessModal = (processedAmount, modalSelector) => {
    $('#'+ modalSelector).modal('hide');
    $('#processed-btc-amount').text(processedAmount);
    $('#loan-box').addClass('form-block-border-blue');
    $('#refillSuccess').modal('show');
}

export const openRefillModal = () => {
    const requestedLoanAmount = getRequestLoanAmount();
    const loanAmountDeposit = Math.round(requestedLoanAmount * 1.2 * 100) / 100;
    const balanceUsd = getCurrentUsdBalanceAmount();
    if (balanceUsd <= 0) {
        refillNoMoneyModalDisplay(requestedLoanAmount, loanAmountDeposit)
    } else {
        refillNotEnoughModalDisplay(requestedLoanAmount);
    }
}

export const checkMaxAmountUsd = (selectorName) => {
    const usdValueSelector = $('#' + selectorName + '');
    if (usdValueSelector.val() > MAX_AMOUNT_VALUE || usdValueSelector.length > 10) {
        usdValueSelector.val(MAX_AMOUNT_VALUE)
    }
}

const refillSuccessClose = () => {
    $('#refillSuccess').on('hidden.bs.modal', function (e) {
        window.location.reload();
    })
}

export const calcLoanLimitValue = (refillAmount = 0, reverse = false) => {
    let newLoanLimit;
    const loanLimit = getCurrentLoanLimit();
    let currentLoanLimit = 0;
    if (loanLimit) {
        currentLoanLimit = parseFloat(loanLimit);
    }
    if (reverse) {
        newLoanLimit = Math.round((currentLoanLimit + refillAmount) * 100) / 100;
    } else {
        newLoanLimit = Math.round((currentLoanLimit + refillAmount / 1.2) * 100) / 100;
    }

    return newLoanLimit;
}

$(document).ready(() => {
    refillSuccessClose();
});

window.openRefillModal = openRefillModal;
